(function () {
  const reviewHref = '/pages/reviews';
  const reviewLabel = 'Reviews';

  function textOf(node) {
    return (node && node.textContent ? node.textContent : '').trim().toLowerCase();
  }

  function hasReviews(root) {
    return Array.from(root.querySelectorAll('a')).some((link) => {
      const text = textOf(link);
      return text === 'reviews' || link.getAttribute('href') === reviewHref;
    });
  }

  function insertBeforeSizeGuide(parent, item) {
    const children = Array.from(parent.children);
    const sizeItem = children.find((child) => textOf(child).includes('size guide'));
    if (sizeItem) {
      parent.insertBefore(item, sizeItem);
    } else {
      parent.appendChild(item);
    }
  }

  function addDesktopReviewLink() {
    document.querySelectorAll('#header-group .menu-list__list').forEach((list) => {
      if (hasReviews(list)) return;

      const item = document.createElement('li');
      item.className = 'menu-list__list-item tl-nav-fallback-item';
      item.setAttribute('role', 'presentation');
      item.innerHTML = '<a href="' + reviewHref + '" class="menu-list__link tl-nav-fallback-link"><span class="menu-list__link-title">' + reviewLabel + '</span></a>';
      insertBeforeSizeGuide(list, item);
    });
  }

  function addDrawerReviewLink() {
    document.querySelectorAll('#header-group .menu-drawer__menu.has-submenu').forEach((list) => {
      if (hasReviews(list)) return;

      const item = document.createElement('li');
      item.className = 'menu-drawer__list-item tl-nav-fallback-item';
      item.innerHTML = '<a href="' + reviewHref + '" class="menu-drawer__menu-item menu-drawer__menu-item--mainlist menu-drawer__animated-element focus-inset tl-nav-fallback-link"><span class="menu-drawer__menu-item-text wrap-text">' + reviewLabel + '</span></a>';
      insertBeforeSizeGuide(list, item);
    });
  }

  function addReviewLinks() {
    addDesktopReviewLink();
    addDrawerReviewLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', addReviewLinks);
  } else {
    addReviewLinks();
  }

  new MutationObserver(addReviewLinks).observe(document.documentElement, {
    childList: true,
    subtree: true
  });
})();
